import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);

// Only import JS files here.
import flipSlides from "./flip-slides";
import homeHero from "./home-hero-highlights-gradient";
//import homeVideoScroll from "./home-video-scroll"; // video version
import homeVideoCanvas from "./home-video-canvas"; //webp/canvas version
import homeVideoMobile from "./home-video-mobile";
import logoSlider1 from "./logo-slider-1";
import navigationFixed from "./navigationFixed";
import navigationToggle from "./navigationToggle";
import slider3Pattern from "./slider-3-pattern";
import "./slider3TabFunc.js";
import "./parallaxFunc.js";
import "./footer-video.js";


document.addEventListener("DOMContentLoaded", function () {
	const mm = gsap.matchMedia();

	flipSlides();
	homeHero();
	//homeVideoScroll();  // video version

	// homeVideoCanvas:
	mm.add("(min-width: 768px)", () => {
		homeVideoCanvas();
		return () => {
			ScrollTrigger.getAll().forEach((t) => t.kill());
			gsap.globalTimeline.clear();
		};
	});

	// homeVideoMobile:
	mm.add("(max-width: 767px)", () => {
		homeVideoMobile();
		return () => {
			ScrollTrigger.getAll().forEach((t) => t.kill());
			gsap.globalTimeline.clear();
		};
	});

	logoSlider1();
	navigationFixed();
	navigationToggle();
	slider3Pattern();
	document.dispatchEvent(new Event('slider3:tabs-ready'));
});
